import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { Operator } from '@img-arena/consoles-api-streaming'
import { DataCard } from '@/components/card'
import { OperatorFormButton } from '@/components/forms/OperatorForm'
import { DGEOperatorForm } from '@/components/forms/OperatorForm/OperatorForm.dge'
import { ActionFormItem, ActionsMenu } from '@/components/table/actions'
import { FilterableTable } from '@/components/table/base'
import { STORE_STATUS } from '@/constants/store'
import { ROUTE_PARAM, ROUTE_URL } from '@/router/constants'
import { streamingRestApi } from '@/service/streamingApi'
import { useOperatorsStoreDGE } from '@/stores/operators'

import { DGE_TABLE_COLUMNS, DGE_TABLE_FILTERS } from './operators.dge.table'

const tableId = 'dge-operators-table'

export const OperatorsViewDGE = () => {
  const navigate = useNavigate()

  const { data, pagination, sort, selectedFilters, isFetching, isLoading } = useOperatorsStoreDGE(
    useShallow((state) => ({
      data: state.data,
      pagination: state.pagination,
      sort: state.sort,
      selectedFilters: state.filters,
      isLoading: state.status === STORE_STATUS.loading,
      isFetching: state.status === STORE_STATUS.fetching
    }))
  )

  const { fetchData, setFilters, setSort, setPagination, resetState } = useOperatorsStoreDGE(
    useShallow((state) => ({
      fetchData: state.fetchData,
      setFilters: state.setFilters,
      setSort: state.setSort,
      setPagination: state.setPagination,
      resetState: state.resetState
    }))
  )

  useEffect(() => {
    fetchData()

    return resetState
  }, [fetchData, resetState])

  const getForm = async (row: Operator) => {
    const { data: operatorDetails } = await streamingRestApi.endpoints.operators.get(row.id)
    return <DGEOperatorForm defaultValues={operatorDetails} onSubmit={fetchData} />
  }

  return (
    <DataCard
      title="Operators"
      headerPostfixActions={<OperatorFormButton.DGE onSubmit={fetchData} />}
    >
      <FilterableTable
        data={data}
        sort={sort}
        tableId={tableId}
        loading={isLoading}
        fetching={isFetching}
        pagination={pagination}
        filters={DGE_TABLE_FILTERS}
        columns={DGE_TABLE_COLUMNS}
        selectedFilters={selectedFilters}
        onPaginationChange={setPagination}
        onFiltersChange={setFilters}
        onSortChange={setSort}
        onRowClick={(row) =>
          navigate(
            ROUTE_URL.OPERATORS.OPERATOR_LICENSES.replace(
              `:${ROUTE_PARAM.OPERATOR_ID}`,
              String(row.id)
            )
          )
        }
        // FIXME: getting CORS and 500 error when trying to edit operator. Could be to do with Argonath service.
        rowActions={
          <ActionsMenu>
            <ActionFormItem getForm={getForm} displaySeparately />
          </ActionsMenu>
        }
      />
    </DataCard>
  )
}
